<template>
  <div>
    <!-- Main Row -->
    <div class="row">
      <!-- Form -->
      <div class="col-md-12">
        <Card :title="'Detail Tipe Remunerasi'">
          <template v-slot:body>
            <div class="row align-items-center">
              <!-- Profile Image -->
              <div class="col-md-4">
                <div class="d-flex justify-content-center align-items-center image-container">
                  <div style="height: 350px; width: 350px; position: relative">
                    <img
                      class="image"
                      src="/images/expense-splash.svg"
                      
                    />
                  </div>
                </div>
              </div>

              <!-- Table Data -->
              <div
                class="col"
                
              >
                <table class="table mb-3">
                  <tr>
                    <td style="width: 25%"><strong>Nama</strong></td>
                    <td>{{ data.name }}</td>
                  </tr>
                  <tr>
                    <td style="width: 25%"><strong>Deskripsi</strong></td>
                    <td>{{ data.description }}</td>
                  </tr>
                  <tr>
                    <td style="width: 25%"><strong>Jenis Remunerasi</strong></td>
                    <td>{{ data.is_tax_name }}</td>
                  </tr>
                  <tr>
                    <td style="width: 25%"><strong>Periode</strong></td>
                    <td>{{ data.period_title }}</td>
                  </tr>
                  <!-- <tr>
                    <td style="width: 25%"><strong>Tanggal Dibayar</strong></td>
                    <td>
                      <div
                        v-for="(date, index) in data.paid_date"
                        :key="index"
                      >
                        <li>
                          {{ data.paid_date[index] }}
                        </li>
                      </div>
                    </td>
                  </tr> -->
                </table>

                <button
                  @click="
                    $router.push({
                      path: '/masters/remuneration-types/Edit/' + data.id,
                    })
                  "
                  class="btn mx-1 btn-success"
                >
                  <i class="far fa-fw fa-edit"></i> Edit
                </button>
                <button
                  @click="deleteData"
                  class="btn mx-1 btn-danger"
                >
                  <i class="far fa-fw fa-trash-alt"></i> Hapus
                </button>
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import module from "@/core/modules/CrudModule.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

export default {
  data() {
    return {
      // Data
      data: {
        name: "",
      },
      // Other
      imgLoaded: false,
    };
  },

  components: {
    Card,
  },

  methods: {
    onImageLoad() {
      this.imgLoaded = true;
    },

    async deleteData() {
      let result = await module.delete(
        "remuneration-types/" + this.$route.params.id
      );
      // If Deleted
      if (result) {
        // Redirect To List
        this.$router.push("/masters/remuneration-types/list");
      }
    },

    async get() {
      this.data = await module.get(
        "remuneration-types/" + this.$route.params.id
      );
      // If Data Not Found
      if (this.data == null) {
        // Redirect To List
        this.$router.push("/masters/remuneration-types/list");
      }
    },
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Tipe Remunerasi", route: "" },
      { title: "Daftar Tipe Remunerasi", route: "/masters/remuneration-types/list" },
      { title: "Detail" },
    ]);
    // Get Data
    this.get();
  },
};
</script>